<template>
    <img src="../assets/drag.svg" class="animation" />
</template>

<script>
export default {
    name: "DropAnim",
    props: {
        appState: String
    }
};
</script>

<style scoped lang="scss">
.animation {
    position: fixed;
    bottom: -48px;
    left: 0px;
    width: 48px;
    height: 48px;
    z-index: 5;
    opacity: 1;

    &-start {
        animation-name: drop;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.5));
    }
}

@keyframes drop {
  0% {
    transform: scale(1, 1);
    opacity: 1;
  }
  10% {
    left: 50px;
    bottom: 50px;
    transform: scale(1, 1);
    opacity: 1;
  }
  50% {
    bottom: 50%;
    left: 50%;
    transform: scale(0.75, 0.75);
    opacity: 1;
  }
  60% {
    bottom: 50%;
    left: 50%;
    transform: scale(0.75, 0.75);
    opacity: 1;
  }
  70% {
    bottom: 50%;
    left: 50%;
    transform: scale(2, 2);
    opacity: 0;
  }
  100% {
    transform: scale(2, 2);
    opacity: 0;
  }
}
</style>
